import * as React from 'react';
import { Helmet } from "react-helmet";
class Header extends React.Component{

  constructor (props) {  
    super(props);
    this.__ = this.props.global.__;
  }

  componentDidMount() {
    // Load scripts dynamically with error handling
    // plugins.js doesn't exist, so it's been removed from the list
    const scripts = [
      this.__("assets/js/scripts.js")
    ];

    scripts.forEach((src) => {
      // Check if script already exists
      const existingScript = document.querySelector(`script[src="${src}"]`);
      if (existingScript) {
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onerror = () => {
        // Silently handle missing scripts - don't show error in console
        console.warn(`Script not found or failed to load: ${src}`);
      };
      script.onload = () => {
        // Script loaded successfully
      };
      document.body.appendChild(script);
    });
  }

  render()
  {
    return (
      
        <>
        <Helmet>
          
          <title>{this.props.global.meta.title}</title>
          <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
          <meta name="description" content={this.props.global.meta.description} />
          <meta name="keywords" content={this.props.global.meta.keywords} />
          
          <link rel="shortcut icon" href={this.__("assets/img/sai/favicon.ico")} />
          <link
            href="https://fonts.googleapis.com/css2?family=Montserrat+Alternates:wght@100;200;300;400;500;600;700;800;900&family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Cinzel:wght@400;600&amily=DM+Sans:wght@400;500;700&family=Parisienne&family=Merriweather+Sans:ital,wght@1,300&family=Merriweather:ital,wght@0,300;0,400;0,700;1,300;1,400&display=swap"
            rel="stylesheet"
          />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.2/css/all.min.css"
          />
          <link rel="stylesheet" href={this.__("/assets/css/plugins.css")} />
          <link href={this.__("assets/css/style.css")} rel="stylesheet" type="text/css" media="all" />
          
          <link rel="shortcut icon" href={this.__("assets/img/sai/favicon.ico")} />
          
          <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossOrigin="anonymous"></script>

        </Helmet>
        </>
    );
  }
}

export default Header;
